<template>
  <div class="wrapper">
    <Header class="confirm-header" :detail="headerInfo" />
    <GoodsInfo class="confirm-goods-info" :detail="goodsInfo" />
    <BaseInfo class="confirm-base-info" :detail="baseInfo" />
    <Footer class="confirm-footer" :detail="footerInfo" :isDisabled="isDisabled" @confirm="confirmOrderHandler" />
  </div>
</template>

<script>
import { Header, Footer, BaseInfo, GoodsInfo } from './components'
import { fetchNoAuthOrderDetail, changeNoAuthOrderStatus } from '@/services/api.index'
import { PROMOTION_TYPE, ORDER_STATUS } from './constants'
export default {
  name: 'ConfirmOrder',
  components: {
    Header,
    Footer,
    BaseInfo,
    GoodsInfo
  },
  data() {
    return {
      isDisabled: false,
      headerInfo: {},
      goodsInfo: [],
      baseInfo: {},
      footerInfo: {}
    }
  },
  async created() {
    const { id } = this.$route.query
    this.getOrderDetail(id)
  },
  methods: {
    async getOrderDetail(id) {
      const { data } = await fetchNoAuthOrderDetail(id)
      this.isDisabled = data.webStatus !== 'NEED_CONFIRM'
      // 获取地址
      const { provinceName, cityName, areaName, streetAddress } = data.address
      const address = `${provinceName} ${cityName} ${areaName} ${streetAddress}`
      // 总活动优惠价格
      let fixedTotalPrice = 0
      let fullTotalPrice = 0
      // 头部信息
      this.headerInfo = {
        statusName: ORDER_STATUS[data.status],
        groupName: data.researchGroup.name,
        username: data.customer.realName,
        address
      }
      // 商品信息
      const { items } = data
      console.info('DATA.', data)
      this.goodsInfo = items.map(item => {
        const {
          id,
          name,
          needPayQuantity,
          sendQuantity,
          priceY,
          amount,
          imgUrl,
          skuCode,
          skuPriceY,
          spec,
          promotion,
          promotionDiscountY,
          promotionType,
          promotionReduction,
          minPrice = 0,
          minQuantity = 0,
          syzFlag
        } = item
        const discountPrice = priceY - promotionDiscountY
        const totalPrice = discountPrice * needPayQuantity
        const actType = promotionType
        if (actType === 'FIX_PRICE') {
          fixedTotalPrice += promotionDiscountY * needPayQuantity
        } else {
          fullTotalPrice += promotionDiscountY * needPayQuantity
        }
        const formatActPrice = (promotionReduction / 100).toFixed(2)
        const actTagText = actType === 'FIX_PRICE' ? `一口价：￥${formatActPrice}` : `满${minPrice}减${formatActPrice}`
        return {
          id,
          cover: imgUrl,
          name,
          count: needPayQuantity,
          sendCount: sendQuantity,
          priceY,
          discountPrice,
          amount,
          skuCode,
          skuPriceY,
          spec,
          actFlag: promotion,
          actType,
          actTagText,
          totalPrice,
          minQuantity,
          syzFlag
        }
      })
      // 基本信息
      const { realName } = data.customer
      this.baseInfo = {
        orderNum: data.code,
        createName: data.seller.realName,
        connectName: realName,
        createTime: data.createTime,
        groupName: data.researchGroup.name,
        discount: data.discount,
        sendType: this.baseMethods.sendType(data.sendType),
        address,
        count: data.needPayQuantity,
        remark: data.payRemark
      }
      // 尾部信息
      this.footerInfo = {
        goodsAmount: data.goodsAmount,
        amount: data.amount,
        promotionAmount: data.promotionAmount,
        fixedTotalPrice,
        fullTotalPrice,
        totalStaffAdjustPriceDiscount: data.totalStaffAdjustPriceDiscount
      }
    },
    async confirmOrderHandler() {
      const { id } = this.$route.query
      await changeNoAuthOrderStatus(id)
      this.$message.success('订单提交成功')
      this.getOrderDetail(id)
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  min-height: 100vh;
  background-color: #f7f7f7;
  display: flex;
  flex-direction: column;
  $components: (header, goods-info, base-info);
  @each $key in $components {
    .confirm-#{$key} {
      margin-bottom: 5px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/share/confirm-order/index.vue